document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.advantages__carousel .embla__slide').forEach((slide) => {
        const icon = slide.querySelector('lord-icon')
        if (!icon) return

        slide.addEventListener('mouseenter', () => {
            icon.setAttribute('trigger', 'loop')
        }, { passive: true })

        slide.addEventListener('mouseleave', () => {
            icon.setAttribute('trigger', 'hover');
        }, { passive: true });
    })
})
